import axios from "axios";
import { Message } from 'element-ui' 

const http = axios.create({
  baseURL: "/api",
  timeout: 5000,
  
  headers: {
    'Content-Type': 'application/json;charset=utf-8'
  }
})

// 请求拦截器
http.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('isAuthenticated');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    Message.error('请求参数错误')
    return Promise.reject(error);
  }
);

// 响应拦截器（新增，统一处理错误）
http.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // 处理401/403等状态码
    if (error.response?.status !=200) {
      localStorage.removeItem('isAuthenticated')
      Message.error('登录已过期，请重新登录')
      window.location.href = 'http://sx.lio8.com.cn/' // 跳回登录页
    }
    return Promise.reject(error);
  }
);

export default http;